import { createAction } from '@reduxjs/toolkit';

export const setVariableList = createAction('@setVariableList', (payload) => ({ payload }));
export const setTemplates = createAction('@setTemplates', (payload) => ({ payload }));
export const setActiveRowData = createAction('@setActiveRowData', (payload) => ({ payload }));
export const saveNewTemplate = createAction('@saveNewTemplate', (payload) => ({ payload }));
export const modifyTemplate = createAction('@modifyTemplate', (payload) => ({ payload }));
export const setDeleteTemplate = createAction('@setDeleteTemplate', (payload) => ({ payload }));
export const setDocumentData = createAction('@setDocumentData', (payload) => ({ payload }));
